//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { CommonServices } from "@/services/CommonServices";
import * as OM from "@/model";
import { apiurl } from '@/config';

class _AppConfigClient {

    

                
            getConfig(showSpinner = true): Promise<OM.GlobalConfig> {
                        return CommonServices.defaultGet<OM.GlobalConfig>(apiurl + 'api/AppConfig/GetConfig',{  }, showSpinner);

                    }
    

                
            testDbConnection(showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/AppConfig/TestDbConnection',{  }, showSpinner);

                    }
    

                
            save(
                item:OM.GlobalConfig,showSpinner = true): Promise<void> {
                        return CommonServices.defaultPost<void>(apiurl + 'api/AppConfig/Save', item,{}, showSpinner );

                    }
    

                
            readFileSystemRoot(showSpinner = true): Promise<{ [key:string]:OM.FileSystemNode; }> {
                        return CommonServices.defaultGet<{ [key:string]:OM.FileSystemNode; }>(apiurl + 'api/AppConfig/ReadFileSystemRoot',{  }, showSpinner);

                    }
    

                
            readFileHeaders(
                filePath:string,
                fileType:string,
                delimiter:string,showSpinner = true): Promise<OM.DataTypeDefinition[]> {
                        return CommonServices.defaultGet<OM.DataTypeDefinition[]>(apiurl + 'api/AppConfig/ReadFileHeaders',{ filePath, fileType, delimiter }, showSpinner);

                    }
    }

export let AppConfigClient = new _AppConfigClient();

class _JobResultLogClient {

    

                
            getLog(
                importName:string,
                fileName:string,showSpinner = true): Promise<OM.JobResultLog> {
                        return CommonServices.defaultGet<OM.JobResultLog>(apiurl + 'api/JobResultLog/GetLog',{ importName, fileName }, showSpinner);

                    }
    

                
            downloadLog(
                fileName:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/JobResultLog/DownloadLog',{ fileName }, showSpinner);

                    }
    

                
            getLogList(
                importName:string,showSpinner = true): Promise<string[]> {
                        return CommonServices.defaultGet<string[]>(apiurl + 'api/JobResultLog/GetLogList',{ importName }, showSpinner);

                    }
    }

export let JobResultLogClient = new _JobResultLogClient();

class _LoginClient {

    

                
            login(
                psw:string,showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Login/Login',{ psw }, showSpinner);

                    }
    

                
            refreshLogin(showSpinner = true): Promise<string> {
                        return CommonServices.defaultGet<string>(apiurl + 'api/Login/RefreshLogin',{  }, showSpinner);

                    }
    }

export let LoginClient = new _LoginClient();

class _QuartzClient {

    

                
            getTriggerInfos(
                importRoutineName:string,showSpinner = true): Promise<OM.TriggerInfo[]> {
                        return CommonServices.defaultGet<OM.TriggerInfo[]>(apiurl + 'api/Quartz/GetTriggerInfos',{ importRoutineName }, showSpinner);

                    }
    

                
            startJobNow(
                jobName:string,
                jobGroup:string,showSpinner = true): Promise<void> {
                        return CommonServices.defaultGet<void>(apiurl + 'api/Quartz/StartJobNow',{ jobName, jobGroup }, showSpinner);

                    }
    }

export let QuartzClient = new _QuartzClient();

class _SwaggerFillerClient {

    

                
            swaggetModelFiller(showSpinner = true): Promise<OM.SwaggerModelFiller> {
                        return CommonServices.defaultGet<OM.SwaggerModelFiller>(apiurl + 'api/SwaggerFiller/SwaggetModelFiller',{  }, showSpinner);

                    }
    }

export let SwaggerFillerClient = new _SwaggerFillerClient();

interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}